export default __webpack_public_path__ + "static/media/bedroom7.e1a9d21c.webp";